import { Button, Col, Input, Row, Select, Table, Tag } from "antd";

import ImageBackground from "../components/LearningGraphTool/ImageBackground";
import Accordion from "../components/QandA/Accordion";
// import "./Catalogue.css";

const QandApage = () => {
  return (
    <div className="catalogue-wrapper">
      {/* <ImageBackground style={{ zIndex: 10 }} /> */}
      <Row style={{ alignItems: "end", marginBottom: "68px" }}>
        <Col span={16}>
          <div className="catalogue-title ">FAQ</div>
          <div className="catalogue-heading ">
            Find everything you need to use XR2Learn Platform
          </div>
        </Col>
        <Col span={8} style={{ display: "flex", justifyContent: "end" }}></Col>
      </Row>
      <Row style={{ justifyContent: "center", marginBottom: "20px" }}>
        <Accordion></Accordion>
      </Row>
      {/* <Row style={{ justifyContent: "center", marginBottom: "20px" }}>
        <div className="catalogue-heading ">NFTs</div>
      </Row>
      <Row style={{ justifyContent: "center", marginBottom: "20px" }}>
        <div className="catalogue-heading ">Transactions in XR2Learn</div>
      </Row> */}
      {/* <Row style={{ gap: "12px" }}>
        <Input
          value={searchInput}
          className="catalogue-search"
          suffix={<SearchOutlined style={{ color: "#5F5F6BAB" }} />}
          onChange={(e) => {
            setSearchInput(e.target.value);
            setSelectedType("All Types");
            debouncedSearch(e.target.value);
          }}
        />

        <Select
          value={selectedType}
          onChange={handleTypeChange}
          options={catalogueTypeOptions}
          className="catalogue-select"
        />
      </Row> */}
      {/* <Table
        columns={columns}
        dataSource={catalogueStore.catalogueItems}
        className="catalogue-table"
        pagination={false}
        scroll={{ y: 520 }}
      /> */}
      {/* <CreateUpdateCatalogueItem /> */}
    </div>
  );
};

export default QandApage;
